export type CategoryConfig = {
  key: string;
  emoji?: string;
  imageSource?: string;
  imageAlt?: string;
}

export const categoryConfigurations: CategoryConfig[] = [
  { key: 'allPurchases', emoji: '⭐' },
  { key: 'dining', emoji: '🍽️' },
  { key: 'gas', emoji: '⛽' },
  { key: 'grocery', emoji: '🛒' },
  { key: 'streaming', emoji: '📺' },
  { key: 'drugstore', emoji: '💊' },
  { key: 'takeout_delivery', emoji: '🥡' },
  { key: 'office_supplies', emoji: '📎' },
  { key: 'internet_cable_phone', emoji: '📡' },
  { key: 'fitness', emoji: '🏃' },
  { key: 'travel', emoji: '🏖️' },
  { key: 'travel.airline', emoji: '✈️' },
  { key: 'travel.hotel', emoji: '🏨' },
  { key: 'travel.general', emoji: '🏖️' },
  { key: 'travel.travelPortal', emoji: '🌐' },
  { key: 'travel.rideshare', emoji: '🚗' },
  { key: 'travel.airline.general', emoji: '🛫' },
  { 
    key: 'travel.airline.united',
    emoji: '✈️',
    imageSource: '/programs/united.png',
    imageAlt: 'United Airlines'
  },
  { 
    key: 'travel.airline.delta',
    emoji: '✈️',
    imageSource: '/programs/delta.jpeg',
    imageAlt: 'Delta Airlines'
  },
  { 
    key: 'travel.airline.american',
    emoji: '✈️',
    imageSource: '/programs/aa.webp',
    imageAlt: 'American Airlines'
  },
  { 
    key: 'travel.airline.southwest',
    emoji: '✈️',
    imageSource: '/programs/southwest.jpeg',
    imageAlt: 'Southwest Airlines'
  },
  { 
    key: 'travel.airline.alaska',
    emoji: '✈️',
    imageSource: '/programs/alaska.jpeg',
    imageAlt: 'Alaska Airlines'
  },
  { 
    key: 'travel.airline.hawaiian',
    emoji: '✈️',
    imageSource: '/programs/hawaiian.jpeg',
    imageAlt: 'Hawaiian Airlines'
  },
  { 
    key: 'travel.airline.frontier',
    emoji: '✈️',
    imageSource: '/programs/frontier.jpeg',
    imageAlt: 'Frontier Airlines'
  },
  { key: 'travel.hotel.general', emoji: '🏨' },
  { key: 'travel.transit', emoji: '🚆' },
  { key: 'home_improvement', emoji: '🏠' },
  { key: 'wholesale_club', emoji: '🛒' },
  { key: 'travel.rentalCar', emoji: '🚗' }
]; 